import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, MessageCircle, HelpCircle } from 'lucide-react';
import { brand } from '../mock';

export default function Footer() {
  return (
    <footer className="border-t border-[#1c1710]">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-8 flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2.5">
          <span className="brand-mark"><Camera size={16} strokeWidth={2.2} /></span>
          <span className="font-serif text-[18px] text-[#e6dcc7]">AXSELL</span>
        </div>
        <div className="flex items-center gap-4 flex-wrap">
          <Link to="/ajuda" className="text-sm text-[#a89e87] hover:text-[#d6af6c] inline-flex items-center gap-1.5">
            <HelpCircle size={14} /> Ajuda
          </Link>
          <div className="text-sm text-[#7d735e]">{brand.copyright}</div>
        </div>
      </div>
    </footer>
  );
}
